export default __webpack_public_path__ + "static/media/mastercardMob.b09541df.svg";